import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, ArrowRight } from 'lucide-react';
const includes = ['Cómo generar atención con contenido', 'Cómo convertir seguidores en clientes', 'Cómo crear reels que venden', 'Cómo editar un reels en 20 min. con el metodo 3 steps.'];
export function OfferSection() {
  return <section id="offer" className="px-6 py-32 md:py-48 bg-zinc-950 text-white scroll-mt-10" data-id="element-65">
      <div className="w-full max-w-6xl mx-auto" data-id="element-66">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-67">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-68">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-10 leading-[1.1]" data-id="element-69">
              Aprendé a generar atención y convertirla en clientes.
            </h2>

            <ul className="space-y-6" data-id="element-70">
              {includes.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.2 + i * 0.1
            }} className="flex items-center gap-5" data-id="element-71">
                  <div className="bg-white rounded-full p-1.5 flex-shrink-0" data-id="element-72">
                    <Check className="w-5 h-5 text-black" strokeWidth={3} data-id="element-73" />
                  </div>
                  <span className="text-gray-300 text-[20px]" data-id="element-74">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-white text-black p-10 md:p-14 rounded-[2.5rem] shadow-2xl relative pl-[30px] pr-[30px]" data-id="element-75">
            <div className="absolute -top-5 right-10 bg-black text-white px-6 py-2 rounded-full text-sm md:text-base font-black tracking-wide uppercase shadow-xl" data-id="element-76">
              Acceso Inmediato
            </div>

            <h3 className="text-3xl font-black mb-4" data-id="element-77">Curso Digital Completo</h3>
            <p className="text-xl text-gray-600 mb-10" data-id="element-78">
              Acceso de por vida a todas las lecciones y futuras
              actualizaciones.
            </p>

            <div className="my-12 py-10 border-y border-gray-200" data-id="element-79">
              <div className="flex items-baseline justify-center md:justify-start" data-id="element-80">
                <span className="text-6xl md:text-7xl lg:text-8xl font-black tracking-tighter" data-id="element-81">
                  $29.990
                </span>
                <span className="text-2xl md:text-3xl text-gray-500 font-bold ml-3" data-id="element-82">
                  ARS
                </span>
              </div>
              <p className="text-base md:text-lg font-bold text-gray-400 uppercase tracking-wider mt-4 text-center md:text-left" data-id="element-83">
                Pago único. Sin suscripciones.
              </p>
            </div>

            <button className="w-full bg-black text-white font-black text-xl md:text-2xl h-20 rounded-2xl flex items-center justify-center gap-3 hover:bg-zinc-800 transition-colors active:scale-[0.98] mb-8 shadow-xl" data-id="element-84">
              Quiero empezar ahora <ArrowRight className="w-7 h-7" data-id="element-85" />
            </button>

            <div className="flex items-center justify-center gap-3 text-base md:text-lg text-gray-500 font-medium" data-id="element-86">
              <ShieldCheck className="w-6 h-6" data-id="element-87" />
              Pago seguro a través de Mercado Pago
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}